import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import AcedInput from "../../../components/essentials/input/text/AcedInput";
import Switch from "../../../components/essentials/switch/Switch";

export interface SelectLocationProps {
	withAvailability?: boolean;
}

const SelectLocation: React.FC<SelectLocationProps> = ({
	withAvailability,
}) => {
	const { t } = useTranslation();

	const { control } = useFormContext();
	return (
		<>
			<div className="row-group">
				<AcedInput
					control={control}
					name="city"
					rules={{ required: t("createJob.validation.cityRequired") }}
					placeholder={t("createJob.placeholder.city")}
					label={t("common.words.location")}
				/>
				{withAvailability && (
					<div
						style={{
							display: "flex",
							gap: "10px",
							color: "white",
							alignItems: "center",
						}}
					>
						<Switch
							colorOne={"#f5dd4b"}
							colorTwo={"#bbbbbb"}
							control={control}
							name="availableToTransfer"
						></Switch>
						<label>{t("createJob.avalTrans")}</label>
					</div>
				)}
			</div>
		</>
	);
};

export default SelectLocation;
